import getRequest from '@/api'

const request = getRequest(process.env.VUE_APP_QUALITY_API, 'data')

/**
 * 获取业务数据统计
 */
export function getInspectionBizDataOverview() {
  return request.get('inspectionOverview/bizDataOverview')
}

/**
 * 获取业务数据统计
 */
export function getInspectionDataBoard() {
  return request.get('inspectionOverview/dataBoard')
}

/**
 * 获取业务数据统计
 */
export function getInspectionTodayOverview() {
  return request.get('inspectionOverview/todayOverview')
}

/**
 * 新增使用流程
 */
export function addUseProcess(data) {
  return request.post('usageProcessGuide', data, { disableToast: true })
}

/**
 * 获取使用流程
 */
export function getUseProcessList(data) {
  return request.post('usageProcessGuide/page', data, { disableToast: true })
}
